// Dialog
export const OPEN_DIALOG = 'open-dialog';
export const DIALOG_CLOSED = 'dialog-closed';

// Snackbar
export const PUSH_SNACK = 'push-snack';
